<template>
  <transition name="view" appear>
    <div>
      <div class="mongo-view" v-if="currentView">
        <div class="mongo-cards" v-if="currentView?.cards?.show">
          <div class="mongo-cards-border-container">
            <span class="mongo-hardaware-info-label">
              {{ $t('dbm.hardwareInfo') }}
            </span>
            <MongoDBCards />
          </div>
        </div>
        <div class="mongo-progress">
          <MongoDBDiskUsage v-if="currentView?.progressCard?.show" />
        </div>
      </div>
      <div>
        <MongoDBGraphs />
      </div>
      <div>
        <MongoQueryTable />
      </div>
    </div>
  </transition>
</template>
<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import { DatabaseTypes } from '@/components/Database/database.types';
import MongoDBCards from '@/components/Database/DatabaseContent/MongoDB/MongoDBCards.vue';
import MongoDBDiskUsage from '@/components/Database/DatabaseContent/MongoDB/MongoDBDiskUsage.vue';
import MongoDBGraphs from '@/components/Database/DatabaseContent/MongoDB/MongoDBGraphs.vue';
import MongoQueryTable from '@/components/Database/DatabaseContent/MongoDB/MongoQueryTable.vue';
import { SUB_TYPES } from '@/utils/templates/databaseTemplate/database.constants';

export default {
  components: {
    MongoDBCards,
    MongoDBDiskUsage,
    MongoDBGraphs,
    MongoQueryTable,
  },
  computed: {
    ...mapState('globalState/app', ['chartsTemplate']),
    ...mapState('databaseState/databaseCommonState', [
      'currentDatabaseType',
      'currentDatabaseService',
    ]),
    ...mapState('databaseState/detail', [
      'currentDatabaseInstance',
      'currentSubType',
    ]),
    ...mapGetters('databaseState/databaseCommonState', ['getCurrentDatabase']),
    ...mapGetters('globalState/settings', ['getDurationTime', 'intervalTime']),
    currentView() {
      if (
        this.currentDatabaseType &&
        this.currentSubType &&
        this.currentDatabaseType.key === DatabaseTypes.mg
      )
        return this.chartsTemplate[this.currentDatabaseType.key][
          this.currentSubType.key
        ];
      else return {};
    },
  },
  methods: {
    ...mapActions('databaseState/detail', ['getDatabaseInstances']),
    fetchDatabaseInstances() {
      let databaseInstance = {
        duration: this.getDurationTime,
        serviceId: this.currentDatabaseService.key,
      };
      if (this.currentDatabaseService?.key) {
        databaseInstance.properties = [
          {
            key: 'instance_type',
            value: SUB_TYPES.MONGO_INSTANCE,
          },
        ];
        this.getDatabaseInstances(databaseInstance);
      }
    },
  },
  mounted() {
    this.fetchDatabaseInstances();
  },

  watch: {
    currentDatabaseService(newValue, oldValue) {
      if (!newValue) {
        this.setCurrentDatabaseInstance({});
        this.setDatabaseInstances([]);
      } else {
        this.fetchDatabaseInstances();
      }
    },
    getDurationTime() {
      this.fetchDatabaseInstances();
    },
  },
};
</script>
<style lang="scss" scoped>
.mongo-view {
  margin-top: 1rem;
  display: flex;
}
.mongo-cards {
  width: 50%;
  padding-left: 0.2rem;
  padding-right: 1.8rem;
}
.mongo-progress {
  width: 48%;
  padding: 0.1rem;
}
.mongo-cards-border-container {
  top: 0.25rem;
  border: 0.15rem solid $color-brand-accent;
  position: relative;
  padding: 1rem;
}
.mongo-hardaware-info-label {
  position: absolute;
  top: -0.9375rem;
  left: 1rem;
  color: $color-brand-accent;
  background-color: $bg-primary;
  font-weight: bold;
}
</style>
